export type DataProcessorFieldMetadata = {
  key: string;
  value: string;
};

export type DataProcessorField = {
  id: string;
  value: unknown;
  metadata?: DataProcessorFieldMetadata[];
};

export type FormattedDataProcessorField = {
  id: string;
  value: unknown;
  metadata?: Record<string, string>;
};

export type DataProcessorError = {
  id: string;
  message: string;
};

export type DataProcessorResponse = {
  status: 'success' | 'warning' | 'error';
  message?: string;
  fields?: DataProcessorField[];
  errors?: DataProcessorError[];
};

// Result of a data-processor action that can succeed at the transport
// level but still report a per-operation failure via its `success` field.
// Callers must branch on `success` and surface `message` on failure.
export type DataProcessorResult =
  | { success: true }
  | { success: false; message?: string };

export type MobileVerificationOtpResult = DataProcessorResult;

export const SUCCESS_FIELD_ID = 'success';
export const MESSAGE_FIELD_ID = 'message';
